module.exports = {
    'es.shopcart': {
        next: 'Siguiente',
        back: 'Anterior',
        cart: 'Artículos',
        client_data: 'Datos del cliente',
        client: 'Datos del cliente',

        payment: 'Forma de pago',
        payment_types: 'Selecciona una forma de pago dando clic en ella.',
        payment_paypal_title: 'Pago Online con Paypal.',
        payment_cash_title: 'Pago en destino.',
        payment_tpv_title: 'Pago con tarjeta de crédito / débito.',
        payment_paypal_description: 'No necesitas una cuenta de paypal para pagar.',
        payment_cash_description: 'Puedes pagar en Valencia a nuestro guía oficial.',
        payment_tpv_description: 'Comercio electrónico seguro.',
        check: 'Comprobación',
        check_data: 'Verifica los datos y método de pago antes de continuar',

        name: 'Nombre',
        lastname: 'Apellido',
        full_name: 'Nombre y apellido',
        phone: 'Teléfono ',
        email: 'E-mail',
        address: 'Tu dirección',
        city: 'Ciudad ',
        country: 'País',
        postal: 'Código postal',
        observations: 'Observaciones',
        product_pickPoint: 'Punto de recogida',
        product_time: 'Duración',
        product_return: 'Fecha y hora de regreso',
        product_start: 'Fecha y hora de inicio',
        product_passengers: 'Pasajeros',
        product_meeting: 'Recogida',
        product_meeting_text: 'Recogida',
        product_destination: 'Destino',
        product_destination_text: 'Destino',
        product_extras: 'Extras',
        icon_next: 'gli-next',
        article: 'Artículo',
        quantity: 'Cantidad',
        price: 'Precio',
        total: 'Total',
        price_notice: 'Los precios incluyen iva.',
        pay: 'Pagar',
        end: 'Confirmar',
        error_message: 'Error en la compra, vuelve a intentarlo',
        retry: 'Reintentar',
        cif: 'Dni/Nif'
    },
    'en.shopcart': {
        next: 'Next',
        back: 'Back',
        cart: 'Articles',
        client_data: 'Client data',
        client: 'Client data',
        payment: 'Method of payment',
        payment_types: 'Select a payment method by clicking on it.',
        payment_paypal_title: 'Online Payment with Paypal',
        payment_cash_title: 'Payment on destination.',
        payment_tpv_title: 'Payment by credit / debit card.',
        payment_paypal_description: 'You do not need a paypal account to pay.',
        payment_cash_description: 'You can pay in Valencia to our official guide.',
        payment_tpv_description: 'Secure electronic commerce.',
        check: 'Checkup',
        check_data: 'Verify details and payment method before continuing',

        name: 'Name',
        lastname: 'Last name',
        full_name: 'Full name',
        phone: 'Phone',
        email: 'E-mail',
        address: 'Address',
        city: 'City ',
        country: 'Country',
        postal: 'Postal code',
        observations: 'Observations',
        product_pickPoint: 'Pick point',
        product_time: 'Duration',
        product_return: 'Return date and time',
        product_start: 'Start date and time',
        product_passengers: 'Passengers',
        product_meeting: 'Pick up',
        product_meeting_text: 'Pick up',
        product_destination: 'Destination',
        product_destination_text: 'Destination',
        product_extras: 'Extras',
        icon_next: 'gli-next',
        article: 'Article',
        quantity: 'Quantity',
        price: 'Price',
        total: 'Total',
        price_notice: 'Prices include VAT.',
        pay: 'Pay',
        end: 'Confirm',
        error_message: 'Purchase failed, please try again',
        retry: 'Retry'
    },
    'fr.shopcart': {
        next: 'Suivant',
        back: 'Précédent',
        cart: 'Articles',
        client_data: 'Informations client',
        client: 'Informations client',
        payment: 'Mode de paiement',
        payment_types: 'Sélectionnez un mode de paiement en cliquant dessus.',
        payment_paypal_title: 'Payez en ligne avec Paypal.',
        payment_cash_title: 'Paiement à l’arrivée.',
        payment_tpv_title: 'Paiement par carte de crédit / débit.',
        payment_paypal_description: 'N’avez pas un compte PayPal pour payer.',
        payment_cash_description: 'Vous pouvez payer à Valence à notre guide officiel.',
        payment_tpv_description: 'Commerce électronique sécurisé.',
        check: 'Vérification',
        check_data: 'Vérifiez les données et le mode de paiement avant de continuer',

        name: 'Nom',
        lastname: 'Le nom',
        full_name: 'Nom et prénom',
        phone: 'Téléphone',
        email: 'E-mail',
        address: 'Votre adresse',
        city: 'Ville',
        country: 'Pays',
        postal: 'Code postal',
        observations: 'Observations',
        product_pickPoint: 'Point de ramassage',
        product_time: 'Durée',
        product_return: 'Date et heure du retour',
        product_start: 'Date et heure de début',
        product_passengers: 'Passagers',
        product_meeting: 'Recogida',
        product_meeting_text: 'Recogida',
        product_destination: 'Destination',
        product_destination_text: 'Destination',
        product_extras: 'Extras',
        icon_next: 'gli-next',
        article: 'Artículo',
        quantity: 'Cantidad',
        price: 'Precio',
        total: 'Total',
        price_notice: 'Les prix incluent la TVA.',
        pay: 'Payer',
        end: 'Confirmer',
        error_message: 'Erreur d’achat, essayez à nouveau',
        retry: 'Réessayant'
    },
    'es.transfer': {
        type: 'Tipo',
        meeting: 'Recogida',
        meeting_text: 'Recogida',
        destination: 'Destino',
        destination_text: 'Destino',
        passengers: 'Pasajeros',
        round_arrive: 'Ida y vuelta - llegando a Valencia',
        one_arrive: 'Solo ida - llegando a Valencia',
        round_leave: 'Ida y vuelta - Saliendo de Valencia',
        one_leave: 'Solo ida - Saliendo de Valencia',
        airport: 'Aeropuerto de Valencia (Manises)',
        north_station: 'Estación del norte (Centro Valencia)',
        cabanal_station: 'Estación del cabañal (Centro Valencia)',
        joaquin_station: 'Estación Joaquin Sorolla (AVE)',
        port_balearia: 'Puerto de Valencia terminal de Balearia',
        port_trasmediterranea: 'Puerto de Valencia terminal Acciona Trasmediterranea',
        bus_station: 'Estación de Autobuses'
    },
    'en.transfer': {
        type: 'Type',
        meeting: 'Pick up',
        destination: 'Destination',
        passengers: 'Passengers',
        round_arrive: 'Round trip - Arriving Valencia',
        one_arrive: 'One way - Arriving in Valencia.',
        round_leave: 'Round trip - Leaving Valencia',
        one_leave: 'One way - Leaving Valencia.',
        airport: 'Airport of Valencia (Manises)',
        north_station: 'North Station (Center Valencia)',
        cabanal_station: 'Cabañal station (centro Valencia)',
        joaquin_station: 'Joaquin Sorolla station (AVE)',
        port_balearia: 'Port of Valencia Balearia terminal',
        port_trasmediterranea: 'Port of Valencia terminal Acciona Trasmediterranea',
        bus_station: 'Bus station'
    },
    'fr.transfer': {
        type: 'Type',
        meeting: 'Recogida',
        destination: 'Destination',
        passengers: 'Passagers',
        round_arrive: 'Départ-retour - atteindre Valence.',
        one_arrive: 'Départ - atteindre Valence.',
        round_leave: 'Départ-retour - En quittant Valence.',
        one_leave: 'Départ - En quittant Valence.',
        airport: "L'aéroport de Valence (Manises)",
        north_station: 'Gare du Nord (Centre de Valence)',
        cabanal_station: 'Station Cabañal (Centre de Valence)',
        joaquin_station: 'Station Joaquin Sorolla (AVE)',
        port_balearia: 'Terminal portuaire Valence Balearia',
        port_trasmediterranea: 'Valence Port Terminal Acciona Trasmediterranea',
        bus_station: 'Station de bus'
    }
};



// WEBPACK FOOTER //
// ./src/settings/Translations.js